import Vue from 'vue'
import {store} from "@store/store";
import protos from "@store/prototypes";
import { fromObjToQueryStr } from "@store/prototypes";

const blkServices = [
    { mod: 'crules', func: 'RefreshResources', blk: 1 },
    { mod: 'crules', func: 'jCurrentAggAdd', blk: 1 },
    { mod: 'crules', func: 'jCurrentAggRemove', blk: 1 },
    { mod: 'crules', func: 'jCurrentRuleDump', blk: 1 },
    { mod: 'crules', func: 'jCurrentRuleEval', blk: 1 },
    { mod: 'crules', func: 'jCurrentRuleSet', blk: 1 },
    { mod: 'crules', func: 'jCurrentRuleStr', blk: 1 },
    { mod: 'crules', func: 'jDividerSet', blk: 1 },
    { mod: 'crules', func: 'jEval3D', blk: 2 },
    { mod: 'crules', func: 'jEval3D2', blk: 2 },
    { mod: 'crules', func: 'jEval3D_WALLS', blk: 2 },
    { mod: 'crules', func: 'jEvalJob', blk: 2 },
    { mod: 'crules', func: 'jEvalTop', blk: 2 },
    { mod: 'crules', func: 'jEvalTop2', blk: 2 },
    { mod: 'crules', func: 'jHeaderSet', blk: 1 },
    { mod: 'crules', func: 'jInitApplica', blk: 1 },
    { mod: 'crules', func: 'jLoadItem', blk: 1 },
    { mod: 'crules', func: 'jLoadItemDt', blk: 1 },
    { mod: 'crules', func: 'jLoadRule', blk: 1 },
    { mod: 'crules', func: 'jPopVariantDt', blk: 1 },
    { mod: 'crules', func: 'jRuleGet', blk: 1 },
    { mod: 'crules', func: 'jRulePopVariant', blk: 1 },
    { mod: 'crules', func: 'jRuleSetParam', blk: 1 },
    { mod: 'projects', func: 'jSaveProject', blk: 1 }
];

export const bus = new Vue();

export const Dau = {
    userPassword: undefined,  // stores locally to renovate
    datalimits:0,
    _unique:0,
    /** Render farm authorization data
     *
     */
    rfAuth: {
        aToken: null,
        rToken: null
    },
    getunique() {
        return ('U'+this._unique++);
    },
    d: {
        trans: { },
        mustsavetrans:false,
        menudes:{}
    },
    screens: { },
    isdebug(){
           return this.g.config.debug;
    } ,
    T(a) {
        return store.getters.translate(a);
        // perform translations
        /*var sc=this;
        if (a && typeof(a)=="string") {
            var b=a.toLowerCase().trim();
            // console.log(sc.d.trans);
            if (sc.d.trans[b]) return sc.d.trans[b];

            console.log( store.getters.translate(a) );

            sc.d.trans[b]=a;
            sc.d.mustsavetrans=true;
        }
        return a;*/
    },
    pushlog(lg) {
        if (lg.errdes) { 
            this.g.iserror=true;    
            this.g.lasterror=lg;
        } else {
            this.g.iserror=false;
            this.g.lasterror="";                
        }
        store.dispatch('logpush',lg);
    },
    g: {
        userId: localStorage.userId,
        userName: localStorage.userName,
        backsite: localStorage.backsite,
        userImg: undefined,
        pk1:undefined,
        pk2:undefined,
        shop: localStorage["shop_" + localStorage.userId],
        _UID: null,
        data: undefined,
        lastErrMsg: undefined,
        lastErrNumber: 0,
        lasterror:{},
        progress: 0,
        menu: {},
        printings: [],
        starttime: new Date().getTime(), // tempo passato per ogni chiamata!!
        lasttime: new Date().getTime(),
        tottime: 0, // totale tempo servizi server
        tottime2: 0, // totale tempo servizi client
        totbytess: 0,
        totbytesr: 0,
        catalogo: localStorage.defCatalog,
        lang: "",
        isguest: false,
        guest: {
            UGUEST:'',
            name: ''
        },
        enablemsglog: 0,
        iserror:false
    },
    // file version
    logversion() {
        console.log('hello from dau.js v1.0');
    },
    uid103() {
        return this.g._UID ? this.g._UID.substring(0, 36) + '103' : '';
    },
    navigate(f) {
        window.open(f, '_blank');
    },
    compk1(service,funct,params,callback,callbackerr) {
        if (params == undefined) params = {};
        params.pk1=this.g.pk1;
        this.com(service,funct,params,callback,callbackerr);    
    },
    comg(service,funct,params,callback,callbackerr) {
        if (params == undefined) params = {};
        params.UGUEST = this.g.guest.UGUEST || '';
        this.com(service,funct,params,callback,callbackerr);    
    },
    com(service,funct,params,callback,callbackerr) {

        // -------------  per prima cosa sistem i parametri mancanti  -----
        var vm=this;
        if (params == undefined) params = {};
        var ct = params.Catalogo;
        if (ct == '.') { params.Catalogo = ''; }
        params._UID = vm.uid103();
        // NextApiClient.UID = vm.uid103();
        // NextApiClient.com(service,funct,params,callback,callbackerr);
        if (service == 'logguest') {
            params.UGUEST = vm.g.guest.UGUEST || '';
        }
        if (ct == undefined) params.Catalogo = vm.g.catalogo; // usa sempre il catalogo ottenuto dal login, se non specificato diversamente!
        // se non è definito _UID cercalo e impostalo !!
        if (params._UID) {
            vm.combase(vm.g.backsite, service, funct, params, data => {
                if (callback) callback(data);
            },
            data => {
                // in caso di errore!
                if (this.g.lastErrNumber === 1 || this.g.lastErrNumber === 2) {
                    // sessione scaduta: prova a ricollegare !!!
                    vm.g.iserror = false;
                    vm.trylogin(vm.g.backsite,vm.g.userId,vm.g.userName,vm.userPassword,function(){
                        // reinietta i parametri
                        params._UID = vm.uid103(); 
                        vm.combase(vm.g.backsite,service,funct,params,
                        function(data){
                            if (callback) callback(data);
                        },function(data) {
                            bus.$emit('wait',false);
                            if (callbackerr) callbackerr(data);    
                        });
                    },function(data) {
                        if (callbackerr) callbackerr(data);
                    });
                } else {
                    if (callbackerr) callbackerr(data);    
                }
            });
        } else {
            vm.trylogin(vm.g.backsite,vm.g.userId,vm.g.userName,vm.userPassword,function(){
                vm.combase(vm.g.backsite,service,funct,params,
                function(data){
                    if (callback) callback(data);
                },function(data) {
                    bus.$emit('wait',false);
                    if (callbackerr) callbackerr(data);    
                });
            },function(data) {
                bus.$emit('wait',false);
                if (callbackerr) callbackerr(data);    
            });
        }
    },
    // TODO: Remove from minifyed @oscar
    getWallsJson(cbResult) {
        var vm = this;
        if (!vm.g) {
            if (cbResult) cbResult(null);
            return;
        }
        if (vm.g.wallsJson != null) {
            if (cbResult) cbResult(vm.g.wallsJson);
        } else {
            vm.com('crules', 'jWallcatget', { Catalogo: vm.g.config.pareti || 'PARETI' }, function (json) {
                vm.g.wallsJson = json;
                if (cbResult) cbResult(json);
            });
        }
    },
    /** Login function
     * @param backsite
     * @param userid
     * @param username
     * @param userpassword
     * @param callback
     * @param callbackerr
     */
    trylogin(backsite,userid,username,userpassword,callback,callbackerr) {
        var vm=this;
        store.dispatch('catset',[]);
        vm.g.catalogo = '';

        // Is RSA login
        if(this.isRSALogin && this.RSAkey) {
            this.combase(
                this.g.backsite,
                'LogWeb',
                'RSALoginUserChain',
                {
                    compressed: this.RSAkey,
                    chainid: ''
                },
                (d) => {
                    vm.g._UID = d._UID;
                    vm.getResponse(d);
                    vm.g.userId= d.userID;
                    vm.g.userName= d.userName;
                    if (callback) callback();
                },
                err => {
                    if (callbackerr)
                        callbackerr(err);
                });
            return;
        }
        // Is AZURE login
        if(this.isAdalLogin && this.adalAuthData) {
            // console.log('Perform login ->', this.adalAuthData);

            this.combase(
                this.g.backsite,
                'LogWeb',
                this.g.config.chainid ? 'jADALoginChain' : 'jADALogin', {
                    UPN: Dau.adalAuthData.userName,
                    azureoid: Dau.adalAuthData.profile.oid, chainid: this.g.config.chainid || ''
                },
                res => {
                    if (res === undefined) {
                        if (callbackerr)
                            callbackerr('Undefined response');
                        return;
                    }

                    this.g._UID = res._UID;
                    this.getResponse(res);
                    this.combase(
                        this.g.backsite,
                        'query',
                        'SetClientTime',
                        {
                            dt: (new Date()).toDouble(),
                            _UID: this.g._UID
                        },
                        e => {
                            if (callback)
                                callback(res);
                        });
                },
                err => {
                    this.g.lastErrMsg = 'not connected (ADAL)!';
                    this.g.lastErrType = 2;
                    this.g.UPN = null;
                    this.g.azureoid = null;
                    if (callbackerr)
                        callbackerr(err);
                });
            return;
        }
        if (username && userpassword && userid>0) {
            vm.combase(backsite, 'LogWeb', vm.g.config.chainid ? 'jWebLoginChain' : 'jWebLogin', 
            { UserID: userid, UserName: username, Password: userpassword || '', ShopId: vm.g.shopId || '', chainid: vm.g.config.chainid || '' },
                function (d) {
                    vm.g._UID = d._UID;
                    vm.getResponse(d);
                    vm.g.userId= localStorage.userId=userid;
                    vm.g.userName= localStorage.userName=username;
                    vm.userPassword= userpassword;
                    if (callback) callback();
                },
                function (d) {
                    if (callbackerr) callbackerr(d);    
            });

        } else if (vm.g.config.isguest) {
            vm.combase(backsite, "LogWeb", vm.g.config.chainid ? 'GuestGetUIDChain' : 'GuestGetUID',  { Modo: 103, chainid: vm.g.config.chainid || '' },
            function (d) {
                vm.g._UID = d._UID;
                vm.getResponse(d);
                if (callback) callback();
            },
            function (d) {
                if (callbackerr) callbackerr(d);
            });    
        } else {
            var lg={
                loctime:new Date().getTime(),
                module:"TRYLOGIN",
                errdes:"missing information to login!"
            };
            vm.pushlog(lg);    
            if (callbackerr) callbackerr(lg.errdes);
        }
    },
    combase(server,service,funct,data,callback,callbackerr) {
        var lg={
            loctime:new Date().getTime(),
            
            module:server==this.g.backsite?service:server+'/'+service,
            func:funct,
            params:JSON.parse(JSON.stringify(data)),
        };
        delete (lg.params.Password); // security on log
        delete (lg.params._UID); // security on log
        if (!lg.params._ext) delete (lg.params._ext);
        
        this.postAjax(server+'/'+service+'.asmx/'+funct,data,lg,callback,callbackerr);
    },
    maybejson(xx) {
        if (!xx) return false;
        if(xx.trim)
            xx = xx.trim();
        let ini=xx.slice(0,1);
        let fin=xx.slice(-1);
        if (ini=='{' && fin=='}') return true;
        if (ini=='[' && fin==']') return true;
        return false;
    },
    postAjax(url,data,lg,success,errore) {
        var sc=this;
        sc.g.lastErrNumber=0;
        sc.g.lastErrMsg=lg.errdes='';
        lg.result=undefined;
        var params=Object.keys(data).map(function(k) {
            return encodeURIComponent(k)+'='+encodeURIComponent(data[k]);
        }).join('&');
        lg.bytess=params.length;
        sc.totbytess=+lg.bytess;
        
        var xhr=new window.XMLHttpRequest();
        xhr.open('POST',url);
        
        var tmm=function() {
            lg.errdes=sc.g.lastErrMsg="SERVER "+url+" NOT AVAIABLE!";
            sc.pushlog(lg);
            if (errore) errore(lg.errdes);
        };
        xhr.onerror=tmm;
        xhr.onabort=tmm;

        xhr.onreadystatechange=function() {
            
            if (xhr.readyState>3 && xhr.status>=200) {
                var xx=null;
                var parser = new DOMParser();
                lg.bytesr=xhr.response.length;    
                sc.totbytesr=+lg.bytesr;
                var xmlDoc = parser.parseFromString(xhr.response, "text/xml");
                x = xmlDoc.getElementsByTagName('millisec');
                lg.svrtime=(x && x.length > 0)? parseFloat(x[0].textContent):0;
                lg.loctime = new Date().getTime() - lg.loctime;
                x = xmlDoc.getElementsByTagName('Message');
                lg.message=(x && x.length > 0)?x[0].textContent.trim():'';
                x = xmlDoc.getElementsByTagName('Data');
                lg.datetime=(x && x.length > 0)?x[0].textContent.split('.')[0]:'';
                
                x = xmlDoc.getElementsByTagName('Risposta');
                if (x && x.length > 0) x = x[0];
                if (x && x.childNodes && x.childNodes.length > 0) {
                    xx = x.childNodes[0].nodeValue;
                    // TODO: SCHIFO
                    if (sc.maybejson(xx)) {
                        try {
                            xx = JSON.parse(xx);
                        } catch (e) {
                            lg.errdes=sc.g.lastErrMsg=e.message;
                            sc.g.lastErrNumber = parseInt(sc.g.lastErrMsg.split('-')[0]);
                            xx = null;
                        }
                    }
                } else {
                    xx=null;
                    var x = xmlDoc.getElementsByTagName('ErrDes');
                    sc.g.lastErrMsg=lg.errdes=(x && x.length > 0)?x[0].textContent:xhr.response;
                    sc.g.lastErrNumber = parseInt(sc.g.lastErrMsg.split('-')[0]);
                }

                sc.pushlog(lg);
                if(lg.errdes) {
                    if(window._APP && window._APP.err_logs)
                        console.error(sc.g.backsite + '/' + lg.module + '.asmx?op=' + lg.func, lg.errdes);

                    if (errore) errore(lg.errdes,xx);
                } else {
                    lg.result=xx;
                    if (success) success(xx);        
                }
            } 
            
            
        }
        xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
        xhr.send(params);
        return xhr;
    },
    /*getJson(url,success,error) {
        var xhr=new XMLHttpRequest();
        xhr.open('GET',url,true);
        xhr.onerror=function() {
            if (error) error('ERROR'+xhr.error);
        };
        xhr.onreadystatechange = function() {
            if (xhr.readyState>3 && xhr.status>=200) {
                try {
                    var tm = JSON.parse(this.responseText);
                } catch (e) {
                    if (error) {
                        if (xhr.status==404) {
                            error('file not found: '+url);
                        } else {
                            error(e) ;
                        }
                    }
                    return;
                }
                if (success) success(tm);
            }
        };
        
        xhr.send();
        return xhr;
    },*/
    getResponse (d) {
        var vm=this;
        vm.g.userId = d.userID;
        vm.g.userName = d.userName;
        vm.g.userData = d.userData;
        vm.g.userImg = d.userImg;
        vm.g.shop = d.shop;
        store.dispatch('storeset',d.shops);
        store.dispatch('catset',d.cats);
        
        vm.g.grpdata = d.grpdata;
        vm.g.seller = d.seller;
        vm.g.sellerdes = d.sellerdes;
        vm.g.userLang = d.userLang;
        if (d.moduli)
            vm.g.moduli = d.moduli.split(';');
        vm.g.isadmin = d.admin;
        vm.g.isguest = d.guest;
        vm.g.guest = {};
        vm.g.isshopadmin = d.shopadmin;
        vm.g.version = d.version;
        vm.g.lastdate = new Date();
        vm.g.extra = d.extra;
        var tm = vm.g.config.catalogdefault ? vm.g.config.catalogdefault.toUpperCase() : undefined;
        var aa = "";
        var fl = false;
       // vm.checklang();
        fl = false;
        if (d.cats && d.cats.length > 0) {
            d.cats.forEach(function (x) {
                if (!x.local) {
                    if (x.cod == tm || aa == "") aa = x.cod;
                }
            });
            vm.g.catalogo = aa;

            for (var i = 0; i < d.cats.length; i++)
                if (d.cats[i].cod == vm.g.catalogo) { fl = true; break; }
            if (!fl) vm.g.catalogo = d.cats[0].cod || '';
        }
    },
    /*sessionend(callback) {
        this.combase(this.g.backsite, "query", "SessionEnd", { _UID: this.uid103() },
        d => {
            // this.g._UID = undefined;
            this.g.isadmin = this.g.isguest = false;
            if (callback) callback(d);
        });
    },*/
    checklang (callback) {
        var vm=this;
        if (vm.g.userLang && vm.g.userLang.length > 0) {
            vm.setLang(vm.g.userLang,callback);
        } else if (vm.g.shop && vm.g.shop.lang) {
            vm.setLang(vm.g.shop.lang,callback);
        } else if (vm.g.shop && vm.g.shop.country) {
            vm.setLang(vm.g.shop.country,callback);
        } else {
            vm.setLang('EN',callback);
        }
    },
    setLang(lang,callback) {
        if(lang === 'DE')
            lang = 'D';

        this.com('query', 'jTranslation', { name: this.g.config.transname || '', lang: lang }, (json) => {
            store.commit('setTranslations', json);
            /*delete vm.d.trans;
            vm.d.trans = {}
            Object.keys(json).forEach( function(v) {
                vm.d.trans[v]=json[v];
            });*/
            // vm.d.mustsavetrans = false;
            this.g.lang = lang;
            if (callback) callback();
        });
    },
    downloadReq(filename, prjId, cb, cbErr) {
        let xhr = new XMLHttpRequest();
        let params = {
            projectId: ''+ prjId,
            fileName: filename,
            _UID: this.uid103()
        };

        xhr.open(
            "POST",
            Dau.g.backsite + '/soapdownload.ashx',
            true
        );

        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                if(cb)
                    cb(xhr.response);
            } else {
                if(cbErr)
                    cbErr(xhr.response);
            }
        };
        xhr.onerror = () => {
            if(cbErr)
                cbErr(xhr.response);
        };
        xhr.send(fromObjToQueryStr(params));
    },
    downloadFile(filename, prjId, cb, cbErr) {
        let xhr = new XMLHttpRequest();
        // const formData = new FormData();
        let formData = document.createElement("form");
        /*formData.append("_UID",this.uid103());
        formData.append("projectId", prjId);
        formData.append("filename", filename);*/

        formData.setAttribute("method", "post");
        formData.setAttribute("action", Dau.g.backsite + '/soapdownload.ashx');
        formData.setAttribute("target", '_blank');

        // formData.setAttribute("_UID", this.uid103());
        // formData.setAttribute("projectId", prjId);
        // formData.setAttribute("filename", filename);
        let params = {
            projectId: ''+ prjId,
            fileName: filename,
            _UID: this.uid103()
        };
        let vv = Object.keys(params);

        for (let i=0; i < vv.length; i++) {
            let paramKey = vv[i];
            let paramValue = params[paramKey].replace(/"/g, '|'); // escape quotes
            let y = document.createElement("input");
            y.setAttribute("type", "hidden");
            y.setAttribute("name", paramKey);
            y.setAttribute("value", paramValue);
            formData.appendChild(y);
        }

        document.body.appendChild(formData);
        formData.submit();
        formData.remove();

        /*xhr.open("POST",this.g.backsite+"/soapdownload.ashx",true);
        xhr.onload = () => {
            if (xhr.status === 200) {
                cb(JSON.parse(xhr.response));
            } else {
                try {
                    cbErr(JSON.parse(xhr.response));
                }
                catch(err) {
                    cbErr(xhr.response);
                }
            }
        }
        xhr.send(formData);*/
    },
    uploadFiles(filelist, prjId, cb, cbErr) {
        let xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', e => {
            let percent_complete = (e.loaded / e.total)*100;
            // Percentage of upload completed
            console.log('%c'+ percent_complete, 'fonst-size: x-large; color: blue;');
        });

        const formData = new FormData();

        formData.append("_UID",this.uid103());
        formData.append("projectId", prjId);
        formData.append("uploadmode",0);
        Array.from(Array(filelist.length).keys())
            .map(x => {
                // formData.append(filelist[x].name, filelist[x]);
                formData.append(filelist[x].name, filelist[x]);
            });

        xhr.open("POST",this.g.backsite+"/soapupload.ashx",true);
        xhr.onload = () => {
            if (xhr.status === 200) {
                cb(JSON.parse(xhr.response));
            } else {
                try {
                    cbErr(JSON.parse(xhr.response));
                }
                catch(err) {
                    cbErr(xhr.response);
                }
            }
        }
        xhr.send(formData);
    },
    downalodSceneObj(jsonScene) {
        let xhr = new XMLHttpRequest();
        let formData = document.createElement("form");

        formData.setAttribute("method", "post");
        formData.setAttribute("action", Dau.g.backsite + '/exportobjscenedownload.ashx');
        formData.setAttribute("target", '_blank');


        let params = {
            jsonScene: jsonScene.jsonScene,
            _UID: this.uid103()
        };
        let vv = Object.keys(params);

        for (let i=0; i < vv.length; i++) {
            let paramKey = vv[i];
            let paramValue = params[paramKey];//.replace(/"/g, '|'); // escape quotes
            let y = document.createElement("input");
            y.setAttribute("type", "hidden");
            y.setAttribute("name", paramKey);
            y.setAttribute("value", paramValue);
            formData.appendChild(y);
        }

        document.body.appendChild(formData);
        formData.submit();
        formData.remove();
    },
    sendFiles(fileList, type,name,newname,dim,linklist,callback,callerr, uid) {
        if (!fileList.length && !linklist)
            return;

        const vm = this;
        const formData = new FormData();
        let catalogo = vm.g.catalogo;
        Array.from(Array(fileList.length).keys())
          .map(x => {
            formData.append(type, fileList[x], fileList[x].name);
          });
        
        formData.append("CATALOGO",catalogo); // usa sempre il catalogo ottenuto dal login, se non specificato diversamente!
        formData.append("_UID",vm.uid103() || uid);
        formData.append("Name",name || '');
        formData.append("NewName",newname || '');
        formData.append("Type",type || '');
        formData.append('Dim',dim || '');
        formData.append('linklist',linklist || '');
        
        let lg={
            loctime:new Date().getTime(),
            module:"upload.ashx",
            func:"none",
            params:JSON.parse(JSON.stringify({
                Catalogo:catalogo,
                Name:name || '',
                NewName:newname || '',
                Type:type || '',
                Dim:dim || '',
                linklist:linklist || '',             
            })),
        }

        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', e => {
            let percent_complete = (e.loaded / e.total)*100;

            // Percentage of upload completed
            console.log('%c'+ percent_complete, 'fonst-size: x-large; color: blue;');
        });
        xhr.open("POST",vm.g.backsite+"/upload.ashx",true);
        xhr.onload = () => {
          if (xhr.status === 200) {
              lg.bytesr=xhr.response.length;    
              lg.loctime = new Date().getTime() - lg.loctime;
              setTimeout(()=>{
                let rr=xhr.response;
                if (rr.startsWith('E-')) {
                    lg.errdes=rr;
                    if (callerr) callerr(rr);
                } else {
                    let r1=null;
                    if (vm.maybejson(rr)) {
                        try {
                            r1 = JSON.parse(rr);
                        } catch (e)  {}
                    }    
                    if (r1) {
                        lg.result=r1;
                        if (callback) callback(r1)
                    }   else {
                        lg.result=rr;
                        if (callback) callback(rr)
                    } 
                }
                vm.pushlog(lg);
            },1000)  // messo un timeout per impedire abusi alla chiamata!
          } else {
             if (callerr) callerr('E-99')
          }    
        }
        xhr.send(formData);
    },
    printnaviga(params, nw, callback) {
        const vm = this;
		if (params == undefined) params = {};

		var ct = params.Catalogo;
		if (ct == '.') {
			params.Catalogo = '';
		} else if (!ct) {
			params.Catalogo = vm.g.catalogo;
		}

		params._UID = vm.uid103();
		if (!vm.g._UID) {
			if (callback) callback("E01-must connect");
			return;
		}
		params.UGUEST = vm.g.guest.UGUEST || '';
		if (nw) {
			params.attach = 'NO';
			var newWindow = window.open('', '_blank');
			newWindow.document.write('<form id="tmpForm" method="post" action="' + vm.g.backsite + '/xPdfHandler.ashx">');
			Object.keys(params).forEach(function (paramKey) {
				if (!params.hasOwnProperty(paramKey))
					return;
				var paramValue = (params[paramKey] + '').replace(/"/g, '|');

				newWindow.document.write('<input type="hidden" name="' + paramKey + '" value="' + paramValue + '" />');
			});
			newWindow.document.write('</form>');
			newWindow.document.getElementById('tmpForm').submit();
		} else {
			let x = document.createElement("form");
			x.setAttribute("method", "post");
			x.setAttribute("action", vm.g.backsite + '/xPdfHandler.ashx');
			var vv = Object.keys(params);
			for (var i = 0; i < vv.length; i++) {
				var paramKey = vv[i];
				var paramValue = params[paramKey].replace(/"/g, '|'); // escape quotes
				var y = document.createElement("input");
				y.setAttribute("type", "hidden");
				y.setAttribute("name", paramKey);
				y.setAttribute("value", paramValue);
				x.appendChild(y);
			};
			document.body.appendChild(x);
			x.submit();
			// delete x;
		}
    },
    /** -- Important function --
     * Allow to load a component from custom folder if it exist, otherwise a configurator folder component is used
     * @param componentPath
     * @returns {Promise}
     */
    import(componentPath) {
        return new Promise((resolve, reject) => {
            import('@custom/' + componentPath)
            .then( module => {
                resolve(module);
            })
            .catch( (missingErr) => {
                if(missingErr.toString().match(/Cannot find module/ig) === null)
                    console.error(missingErr)
                import('@configurator/' + componentPath)
                .then( module => {
                    resolve(module);
                })
                .catch( (err) => {
                    console.error(missingErr)
                    reject();
                })
            });
        })
    },
    /** Get token to create render farm user in background
     * Use callback
     * @param u - User
     * @param p - Password
     * @param cb - Callback success
     * @param cbErr - Callback error
     * @private
     */
    _getRFCreationToken(u,p,cb,cbErr) {
        this.com(
            'RenderfarmAPI',
            'jUserCreationToken2',
            { _UID: this.g._UID, userPwd: p, username: u },
            resp => {
                if(cb)
                    cb(resp);
            },
            err => {
                if(cbErr)
                    cbErr(err);
            }
        );
    },
    /** Get token to create render farm user in background
     * Use promise
     * @param usr - User
     * @param pwd - Password
     * @returns {Promise<any>}
     */
    getRFCreationToken(usr,pwd) {
        return new Promise( (resolve, reject) => {
            this._getRFCreationToken(usr,pwd, (response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    },
    /**
     *
     * @param cData - Creation data
     * @param usrData - Json structure as described in Swagger
     * @param cb - Callback success
     * @param cbErr - Callback error
     * @private
     */
    loginRFUser(cData) {
        return new Promise( (resolve, reject) => {
            
            var req = new XMLHttpRequest();
            var srv = Dau.g.config.rfServer;
            req.open(
                "GET",
                srv + "/user/name:CustomLogin",
                true
            );
            req.setRequestHeader(
                "Content-Type",
                "application/json; charset=UTF-8"
            );

            req.setRequestHeader("tokenNext", JSON.stringify(cData));

            req.onload = () => {
                if (req.status === 200) {
                    console.log(req.response);
                    resolve(req);
                } else {
                    console.error(req.response);
                    reject(req);
                }
            };
            req.onerror = () => {
                reject(req);
            };
            req.send();
        });
    },
    /**
     *
     * @param cData - Creation data
     * @param usrData - Json structure as described in Swagger
     * @param cb - Callback success
     * @param cbErr - Callback error
     * @private
     */
    _createRFUser(cData, usrData, cb, cbErr) {
        var req = new XMLHttpRequest();
        var srv = Dau.g.config.rfServer;
        req.open(

            "POST",
            srv + "/user/name:CustomRegistration",
            true
        );
        req.setRequestHeader(
            "Content-Type",
            "application/json; charset=UTF-8"
        );

        req.setRequestHeader("tokenNext", JSON.stringify(cData));

        req.onload = () => {
            if (req.status === 200) {
                console.log(req.response);
                if(cb)
                    cb(req.response);
            } else {
                console.error(req.response);
                if(cbErr)
                    cbErr(req.response);
            }
        };
        req.onerror = () => {
            if(cbErr)
                cbErr(req.response);
        };
        req.send(JSON.stringify(usrData));
    },
    /** Create new user to Render Farm
     *
     * @param creationData
     * @param userData
     * @returns {Promise<any>}
     */
    createRFUser(creationData, userData) {
        return new Promise( (resolve, reject) => {
            this._createRFUser(creationData, userData, (response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/_eng/store/dau.js